import type { JSX } from 'react';

export interface LauncherFooterProps {
  buildVersion: string;
  /** Connection state — drives the dot color. */
  connected: boolean;
  /** Last-sync label, e.g., "just now", "2 min ago". */
  lastSync?: string;
}

/**
 * Compact bottom strip with build/runtime status. Stays out of the way; the
 * real signal during normal operation is "is the dot green and is the time
 * recent." Fail-to-Core states will surface here too in Phase 4.x.
 */
export function LauncherFooter({
  buildVersion,
  connected,
  lastSync = 'just now',
}: LauncherFooterProps): JSX.Element {
  return (
    <footer className="launcher-footer" data-testid="launcher-footer">
      <span
        className={`launcher-footer__dot${connected ? ' launcher-footer__dot--ok' : ' launcher-footer__dot--down'}`}
        aria-hidden
      />
      <span className="launcher-footer__status">{connected ? 'Connected' : 'Offline'}</span>
      <span className="launcher-footer__sep">·</span>
      <span className="launcher-footer__sync">Last sync {lastSync}</span>
      <span className="launcher-footer__sep">·</span>
      <span className="launcher-footer__version">v{buildVersion}</span>
    </footer>
  );
}
